<div class="parent">
  <div class="parentChildOne">
    <p>
      <i class="far fa-user-circle"></i> <span>Facial recognition </span>
      <i class="fas fa-check"></i>
    </p>
    <p>
      <i class="far fa-building"></i> <span>Account verified </span>
      <i class="fas fa-check"></i>
    </p>
    <p>
      <i class="fas fa-stamp"></i><i></i> <span>Bvn confirmed </span>
      <i class="fas fa-check"></i>
    </p>
    <p>
      <i class="fas fa-vote-yea"></i> <span>Eligibility checked </span>
      <i class="fas fa-check"></i>
    </p>
    <p>
      <i class="fas fa-street-view"></i> <span>Location match </span>
      <i class="fas fa-check"></i>
    </p>
    <p>
      <i class="fas fa-users"></i> <span>Family member matched </span>
      <i class="fas fa-check"></i>
    </p>
  </div>
</div>
